import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { Formik, Form, Field } from 'formik';

import DateMeta from '@components/DateMeta/DateMeta'
import UsePlural from '@connects/plural'

import './NoteCard.scss'
// TODO: write a UseNotes connect to make this read better
// Uses plural as simply provides the actions required to interact with notes
// the actual data is passed in, maybe just pass in the actions too?

@UsePlural('note')
class NoteSingular extends React.Component {

	static propTypes = {
		note: PropTypes.object.isRequired,
		noteNumber: PropTypes.number,
		dateFormat: PropTypes.string,
	};

	static defaultProps = {
		dateFormat: 'Do MMMM YYYY [at] h:mm a',
	}

	constructor(props) {
		super(props);
		this.state = { isEditing: false }
	}

	startEdit() {
		this.setState({ isEditing: true });
	}

	cancelEdit() {
		this.setState({ isEditing: false });
	}

	onSubmit(values, {setSubmitting, ...formikActions}) {
		const {actions, note} = this.props;

		return actions.update(note._id, values)
		.then(res => {
			this.cancelEdit();
		})
		
	}

	deleteNote() {
		const { note, actions } = this.props;
		return actions.delete(note._id);
	}

	render() {
		const {
			dateFormat,
			note,
		} = this.props;

		const {
			isEditing
		} = this.state;

		return (
			<Formik 
				initialValues={note}
				onSubmit={::this.onSubmit}
				enableReinitialize={true}
			>
				{({resetForm, submitForm, dirty}) => (

					<article className="NoteCard">
						<header>
							{this.renderNoteTitle()}
							{this.renderDate(note.createdAt)}
							
							{
								isEditing
								? (
									<div className="NoteCard-buttons">
										<button type="button" onClick={() => { resetForm(); ::this.cancelEdit(); }}>cancel</button>
										<button type="submit" onClick={submitForm} disabled={!dirty}>submit</button>
									</div>
								)
								: (
									<div className="NoteCard-buttons">
										<button onClick={::this.deleteNote}>delete</button>
										<button onClick={::this.startEdit}>edit</button>
									</div>
								) 
							}
						</header>
						<main>
							{
								isEditing
								? (
									<Form>
										<Field name='content' component="textarea" rows="10" />
									</Form>
								)
								: note.content
							}
							{
								note.updatedAt !== note.createdAt
								&& <DateMeta dateFormat={dateFormat} prefix="Edited" on={note.updatedAt} by={note.updatedBy} />
							}

						</main>				
					</article>
				)}
			</Formik>
		)
	}

	renderNoteTitle() {
		const { note, noteNumber } = this.props;
		const titleString = (noteNumber != null ? `Note #${noteNumber} ` : '')+`By ${note.createdBy.label}`;
		return titleString ? <span className="NoteCard-title">{titleString}</span> : '';
	}

	renderDate(date) {
		const { dateFormat } = this.props;
		const dateString = moment(date).format(dateFormat);
		return dateString && <span className="NoteCard-date">{dateString}</span>;
	}
}

export default NoteSingular;


// WEBPACK FOOTER //
// ./src/scenes/Notes/components/NoteCard/NoteCard.jsx